(() => {
  const initializeZaironLeadForms = () => {
    document.querySelectorAll('form[data-zairon-lead-form]').forEach((form) => {
      if (form.dataset.zaironLeadInitialized === 'true') return;

      const params = new URLSearchParams(window.location.search);
      const utmFields = {
        utm_source: 'LEADCF5',
        utm_medium: 'LEADCF6',
        utm_campaign: 'LEADCF7',
        utm_content: 'LEADCF8',
          utm_term: 'LEADCF23'
      };

      Object.entries(utmFields).forEach(([parameter, fieldId]) => {
        const field = form.querySelector('#' + fieldId);
        if (field) {
          field.value = params.get(parameter) || 'no especificado';
        }
      });

      const model = form.querySelector('#LEADCF4');
      const company = form.querySelector('#ZaironCompany');
      if (model) model.value = form.dataset.zaironLeadModel || 'Zs1- Sport';
      if (company) company.value = 'Particular';

      form.addEventListener('submit', () => {
        const firstName = form.querySelector('#ContactForm-name');
        const lastName = form.querySelector('#Last_Name');
        const submit = form.querySelector('#formsubmit');

        if (firstName && lastName) {
          lastName.value = firstName.value.trim();
        }

        if (submit) {
          submit.disabled = true;
        }

        document.charset = 'UTF-8';
      });

      form.dataset.zaironLeadInitialized = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeZaironLeadForms);
  } else {
    initializeZaironLeadForms();
  }

  document.addEventListener('shopify:section:load', initializeZaironLeadForms);
})();
